export function initPagination(containerSelector, itemSelector = '.paginated-item') {
    var list = document.querySelector(containerSelector);
    if (!list) return;

    var pageSize = parseInt(list.getAttribute('data-page-size'));
    var totalPages = parseInt(list.getAttribute('data-total-pages'));
    var items = list.querySelectorAll(itemSelector);
    var pagination = list.parentElement.querySelector('.pagination');
    var pageBtns = pagination ? pagination.querySelectorAll('.page-btn') : [];
    var prevBtn = pagination ? pagination.querySelector('#prev-page') : null;
    var nextBtn = pagination ? pagination.querySelector('#next-page') : null;
    var currentPage = 1;

    function showPage(page) {
        currentPage = page;
        var start = (page - 1) * pageSize;
        var end = start + pageSize;
        items.forEach(function(item, idx) {
            item.style.display = (idx >= start && idx < end) ? 'block' : 'none';
        });
        pageBtns.forEach(function(btn, idx) {
            btn.classList.toggle('--active', idx + 1 === page);
        });
        if (prevBtn) {
            prevBtn.disabled = page === 1;
            prevBtn.classList.toggle('--disabled', page === 1);
        }
        if (nextBtn) {
            nextBtn.disabled = page === totalPages;
            nextBtn.classList.toggle('--disabled', page === totalPages);
        }
    }

    pageBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var page = parseInt(btn.getAttribute('data-page'));
            showPage(page);
        });
    });

    prevBtn && prevBtn.addEventListener('click', function() {
        if (currentPage > 1) showPage(currentPage - 1);
    });

    nextBtn && nextBtn.addEventListener('click', function() {
        if (currentPage < totalPages) showPage(currentPage + 1);
    });

    showPage(1);
}

// Auto-initialize for all lists with .js-paginated-list

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-paginated-list').forEach(function(list) {
        // Use .paginated-item as the item selector for all
        initPagination('#' + list.id, '.paginated-item');
    });
});